// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty-empty-btd5N"};